import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const Stat = ({ label, value, testid, accent }) => (
  <div className="card-soft p-5" data-testid={testid}>
    <p className={`font-display text-3xl font-bold ${accent ? "text-teal" : "text-navy"}`}>{value}</p>
    <p className="text-xs uppercase tracking-[0.12em] text-muted-ink mt-2">{label}</p>
  </div>
);

export const AdminReports = () => {
  const [r, setR] = useState(null);
  useEffect(() => { api.get("/admin/reports").then((x) => setR(x.data)).catch(() => {}); }, []);
  if (!r) return null;
  return (
    <section className="mt-10" data-testid="admin-reports">
      <p className="font-display text-navy text-lg font-semibold">Platform overview</p>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-4">
        <Stat label="Total churches" value={r.churches} testid="report-churches" />
        <Stat label="Monthly revenue (paid plans)" value={`$${r.mrr.toFixed(0)}`} testid="report-mrr" accent />
        <Stat label="New churches this month" value={r.new_this_month} testid="report-new" />
        <Stat label="On trial" value={r.trialing} testid="report-trialing" />
        <Stat label="Volunteers (people)" value={r.volunteers} testid="report-volunteers" />
        <Stat label="Assessments" value={r.assessments} testid="report-assessments" />
        <Stat label="Free assessments" value={r.free_assessments} testid="report-free" />
        <Stat label="Inactive / unpaid" value={r.inactive} testid="report-inactive" />
      </div>
      <div className="card-soft p-5 mt-4" data-testid="report-by-plan">
        <p className="text-xs uppercase tracking-[0.12em] text-muted-ink">Active subscribers by plan</p>
        <div className="flex flex-wrap gap-3 mt-3">
          {Object.keys(r.active_by_plan).length === 0 && <span className="text-sm text-muted-ink">No active subscribers yet</span>}
          {Object.entries(r.active_by_plan).map(([k, v]) => <span key={k} className="chip-btn !cursor-default" data-testid={`report-plan-${k}`}>{k} · {v}</span>)}
        </div>
      </div>
    </section>
  );
};
